var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x87far\xC3\xAB \xC3\xABsht\xC3\xAB aftesia e kufizuar?",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1618,
    transform: "translate(-148 -233)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 238,
    transform: "translate(-148 -189)",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.01008 15.5445H10.9903C11.1478 15.5445 11.2989 15.482 11.4103 15.3706C11.5217 15.2591 11.5843 15.108 11.5843 14.9505C11.5843 14.7929 11.5217 14.6418 11.4103 14.5304C11.2989 14.419 11.1478 14.3564 10.9903 14.3564H9.01008C8.85252 14.3564 8.70142 14.419 8.59001 14.5304C8.4786 14.6418 8.41602 14.7929 8.41602 14.9505C8.41602 15.108 8.4786 15.2591 8.59001 15.3706C8.70142 15.482 8.85252 15.5445 9.01008 15.5445Z",
    fill: "#1C68DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99999 11.1881C10.2087 11.1883 10.4137 11.1334 10.5945 11.0291C10.7752 10.9248 10.9253 10.7748 11.0297 10.5941H13.9604C14.1179 10.5941 14.269 10.5315 14.3804 10.4201C14.4919 10.3087 14.5544 10.1576 14.5544 10C14.5544 9.84245 14.4919 9.69135 14.3804 9.57994C14.269 9.46853 14.1179 9.40594 13.9604 9.40594H11.0297C10.9268 9.22382 10.7762 9.07321 10.594 8.9703V4.05941C10.594 3.90185 10.5315 3.75075 10.4201 3.63934C10.3086 3.52794 10.1575 3.46535 9.99999 3.46535C9.84243 3.46535 9.69133 3.52794 9.57993 3.63934C9.46852 3.75075 9.40593 3.90185 9.40593 4.05941V8.9703C9.17905 9.1009 9.00165 9.30278 8.9013 9.54458C8.80095 9.78637 8.78327 10.0545 8.85101 10.3074C8.91874 10.5603 9.0681 10.7837 9.27587 10.943C9.48364 11.1022 9.7382 11.1884 9.99999 11.1881Z",
    fill: "#1C68DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 20C11.9778 20 13.9112 19.4135 15.5557 18.3147C17.2002 17.2159 18.4819 15.6541 19.2388 13.8268C19.9957 11.9996 20.1937 9.98891 19.8079 8.0491C19.422 6.10929 18.4696 4.32746 17.0711 2.92894C15.6725 1.53041 13.8907 0.578004 11.9509 0.192152C10.0111 -0.1937 8.00043 0.0043328 6.17317 0.761209C4.3459 1.51809 2.78412 2.79981 1.6853 4.4443C0.58649 6.08879 0 8.02219 0 10C0.00627525 12.6502 1.06186 15.1901 2.93586 17.0641C4.80987 18.9381 7.34976 19.9937 10 20ZM10 1.18812C11.7428 1.18812 13.4465 1.70493 14.8956 2.67319C16.3447 3.64145 17.4742 5.01768 18.1411 6.62784C18.8081 8.238 18.9826 10.0098 18.6426 11.7191C18.3026 13.4285 17.4633 14.9986 16.2309 16.2309C14.9986 17.4633 13.4284 18.3026 11.7191 18.6426C10.0098 18.9826 8.238 18.8081 6.62784 18.1411C5.01768 17.4742 3.64145 16.3447 2.67319 14.8956C1.70493 13.4465 1.18812 11.7428 1.18812 10C1.19335 7.66456 2.12342 5.42626 3.77484 3.77484C5.42625 2.12343 7.66455 1.19335 10 1.18812Z",
    fill: "#1C68DA"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1618,
    fill: "white",
    transform: "translate(-148 -233)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock1);
export default __webpack_public_path__ + "static/media/clock1.9f9e47952107bc00db12053069642918.svg";
export { ForwardRef as ReactComponent };